import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SidebarProvider, SidebarInset } from '@/shared/ui/sidebar';
import { VerifiedGate } from '@/components/auth/VerifiedGate';

export function AppLayout(): React.JSX.Element {
  return (
    <VerifiedGate>
      <SidebarProvider>
        <Sidebar />
        <SidebarInset className="flex flex-col">
          <Header />
          <main className="flex-1 p-6 overflow-y-auto">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </VerifiedGate>
  );
}
